namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_textbook, {
		
		Toc_page: {
			flex: {
				basis: '20rem',
				grow: 0,
			},
		},
		
		Text_page: {
			flex: {
				basis: '48rem',
				grow: 1,
			},
		},
		
		Toc: {
			align: {
				self: 'stretch',
			},
		},
		
		Toc_link: {
			minWidth: 0,
			alignItems: 'flex-start',
			flex: {
				grow: 1,
				shrink: 1,
			},
		},

		Toc_title: {
			display: 'block',
			minWidth: 0,
			flex: { grow: 1, shrink: 1 },
			overflowWrap: 'anywhere',
		},
		
		Text: {
			padding: $mol_gap.block,
			flex: {
				grow: 1,
			},
		},
		
	} )
	
}
